<template>
    <div class="login-form">
        <i class="bg-pic"></i>
        <h1 class="l-tit">深圳市二一教育CRM</h1>
        <el-tabs class="login-main">
            <el-tab-pane label="只为提高你的销售业绩">
                <el-form ref="form" :model="form" :rules="rules" :disabled="isDisable">
                    <el-form-item prop="username">
                        <el-input placeholder="请输入账号" prefix-icon="el-icon-user" v-model="form.username" @keyup.enter.native="submitForm" clearable>
<!--                            <i slot="prefix" class="el-input__icon iconfont icon-wode"></i>-->
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" prefix-icon="el-icon-lock" placeholder="请输入登录密码" v-model="form.password" @keyup.enter.native="submitForm" show-password clearable>
<!--                            <i slot="prefix" class="el-input__icon iconfont icon-iconset0114"></i>-->
                        </el-input>
                    </el-form-item>
                    <el-row class="mb20 is-login">
                        <el-col :span="19">
                            <!--<el-checkbox label="自动登录" name="type"></el-checkbox>-->
                        </el-col>
                        <el-col :span="5">
                            <!--<a href="#" class="re-link">忘记密码</a>-->
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-button type="primary" @click="submitForm" :loading="loading" class="l-sunmit">登录
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div class="l-ft">
            Copyright @ 2024 二一教育技术部出品
        </div>
    </div>
</template>

<script>
    import AccountService from "~/services/account";
    import encrypt from "~/common/encrypt";

    export default {
        data() {
            return {
                isDisable: false,
                loading: false,
                form: {
                    username: "",
                    password: ""
                },
                rules: {
                    username: [
                        {
                            required: true,
                            message: "用户名不允许为空",
                            trigger: "blur"
                        }
                    ],
                    password: [
                        {
                            required: true,
                            message: "密码不允许为空",
                            trigger: "blur"
                        }
                    ]
                }
            };
        },
        methods: {
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        // 发送登录请求
                        this.$store.dispatch(
                            'login',
                            {
                                username: this.form.username,
                                password: encrypt.encode(this.form.password)
                            }
                        ).then(res => {
                            if (res == true) {
                                this.$notify({
                                    title: "登录成功",
                                    message: "欢迎进入二一业务系统",
                                    type: "success"
                                });
                                this.$router.push({path: "/home"});
                            }
                            this.loading = false;
                        }).catch(err => {
                            this.loading = false;
                            return false;
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 重置表单
            resetForm() {
                this.$refs["form"].resetFields();
            }
        }
    };
</script>





// WEBPACK FOOTER //
// src/views/pages/login.vue